import CoverageAccordionHeader from "@/components/domains/CoverageAccordionHeader";

const exploringPages = [
  { id: "1", status: "Discovering" },
  { id: "2", status: "Discovering" },
  { id: "3", status: "Discovering" },
];

type Props = {
  expanded?: boolean;
  onToggle?: () => void;
};

export default function LoadingCoverageSection({ expanded = true, onToggle }: Props) {
  return (
    <section id="pages" className="dashboard-section">
      <div className="dashboard-section-body">
        <CoverageAccordionHeader
          title="Pages"
          subtitle="Finding pages on this domain"
          expanded={expanded}
          onToggle={onToggle}
        />

        {expanded ? (
          <div className="mt-4 divide-y divide-gray-100 rounded-lg border border-gray-200 bg-white">
            {exploringPages.map((page) => (
              <div key={page.id} className="flex items-center justify-between gap-4 px-4 py-3">
                <div className="min-w-0 flex-1">
                  <div className="h-4 w-40 animate-pulse rounded bg-gray-200" />
                  <div className="mt-2 h-3 w-24 animate-pulse rounded bg-gray-100" />
                </div>
                <span className="text-sm font-medium text-primary animate-pulse">{page.status}</span>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
}
